var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssignIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "5 4 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17241_21258)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.168 11.8333C10.168 12.7174 10.5192 13.5652 11.1443 14.1904C11.7694 14.8155 12.6172 15.1667 13.5013 15.1667C14.3854 15.1667 15.2332 14.8155 15.8583 14.1904C16.4834 13.5652 16.8346 12.7174 16.8346 11.8333C16.8346 10.9493 16.4834 10.1014 15.8583 9.47631C15.2332 8.85119 14.3854 8.5 13.5013 8.5C12.6172 8.5 11.7694 8.85119 11.1443 9.47631C10.5192 10.1014 10.168 10.9493 10.168 11.8333Z",
    stroke: "#1650FF",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 23.5V21.8333C8.5 20.9493 8.85119 20.1014 9.47631 19.4763C10.1014 18.8512 10.9493 18.5 11.8333 18.5H15.1667C16.0507 18.5 16.8986 18.8512 17.5237 19.4763C18.1488 20.1014 18.5 20.9493 18.5 21.8333V23.5",
    stroke: "#1650FF",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.332 8.6084C20.049 8.79198 20.6846 9.20898 21.1384 9.79366C21.5922 10.3783 21.8386 11.0974 21.8386 11.8376C21.8386 12.5777 21.5922 13.2968 21.1384 13.8815C20.6846 14.4661 20.049 14.8831 19.332 15.0667",
    stroke: "#1650FF",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 23.5V21.8333C23.4958 21.0976 23.2483 20.384 22.7961 19.8037C22.3439 19.2233 21.7124 18.8089 21 18.625",
    stroke: "#1650FF",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17241_21258"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignIcon);
export default __webpack_public_path__ + "static/media/assignIcon.98ee67ccd2bb0a1c7cab085ff8702d7d.svg";
export { ForwardRef as ReactComponent };